import { DEACTIVATE_VAS_CONTROL_DATA_FAILURE, DEACTIVATE_VAS_CONTROL_DATA_REQUEST, DEACTIVATE_VAS_CONTROL_DATA_SUCCESS, } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const deactivateVasControlDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case DEACTIVATE_VAS_CONTROL_DATA_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, error: null });
        case DEACTIVATE_VAS_CONTROL_DATA_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, data: action.payload, error: null });
        case DEACTIVATE_VAS_CONTROL_DATA_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        default:
            return state;
    }
};
export default deactivateVasControlDataReducer;
